import "./App.css";
 
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
 

import Loader from "./Admin/Loader";
import Mainfol from "./Admin/Mainfol";

import ProtectedRoute from "./ProtectedRoute";
import RoleRoute from "./RoleRoute";

import LoginPage from "./Admin/LoginPage";
import Dashboard from "./Admin/Dashboard";
import SuperAdminDashboard from "./Admin/Pages/SuperAdminDashboard";
 
import Unauthorized from "./Unauthorized";
 
 
import Employee from "./Admin/Pages/Employee";
import Attendance from "./Admin/Pages/Attendance";
import Leaves from "./Admin/Pages/Leaves";
import Timestamps from "./Admin/Pages/Timestamps";
 

  
function App() {
  
 

  

   return (
    <BrowserRouter>
      <Loader />

      <Routes>
        {/* Default */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Unauthorized */}
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* PROTECTED */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Mainfol />
            </ProtectedRoute>
          }
        >
          <Route
            path="superadmin/dash"
            element={
              <RoleRoute allowed={["superadmin"]}>
                <SuperAdminDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="dash"
            element={
              <RoleRoute allowed={["admin"]}>
                <Dashboard />
              </RoleRoute>
            }
          />
    <Route
            path="emp"
            element={
              <RoleRoute allowed={["admin"]}>
                <Employee />
              </RoleRoute>
            }
          />
              <Route
            path="atten"
            element={
              <RoleRoute allowed={["admin"]}>
                <Attendance />
              </RoleRoute>
            }
          />
                <Route
            path="leave"
            element={
              <RoleRoute allowed={["admin"]}>
                <Leaves />
              </RoleRoute>
            }
          />
          <Route
            path="timestamps"
            element={
              <RoleRoute allowed={["superadmin"]}>
                <Timestamps />
              </RoleRoute>
            }
          />
        </Route>

        {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>

      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
